import { useQueries } from '@tanstack/react-query';
import { getSavedCryptoAddresses } from '../requests';
import { useDepositWithdrawAssetsDictionary } from '@/shared/api';
import type { SavedCryptoWalletAddress } from '../../model';

type Params = {
  data: SavedCryptoWalletAddress[];
  isLoading: boolean;
  error: Error | null;
};

export function useGetSavedCryptoAddresses(): Params {
  const { depositWithdrawAssetsData, depositWithdrawAssetsLoading } =
    useDepositWithdrawAssetsDictionary();

  const networks = depositWithdrawAssetsData?.value?.withdraw.crypto ?? [];

  const queries = useQueries({
    queries: networks.map(crypto => ({
      queryKey: ['operations/crypto/', crypto.network, '/template'],
      queryFn: () => getSavedCryptoAddresses(crypto.network),
      enabled: networks.length > 0,
      staleTime: 0,
      gcTime: 0,
      retry: 0,
    })),
  });

  const isLoading =
    depositWithdrawAssetsLoading || queries.some(query => query.isLoading);

  const error = queries.find(query => query.error)?.error || null;

  const data: SavedCryptoWalletAddress[] = queries
    .flatMap(query => query.data?.templates ?? [])
    .map(cryptoAddress => ({
      ...cryptoAddress,
      networkIcon:
        networks.find(network => network.network === cryptoAddress.networkName)
          ?.networkIcon ?? '',
    }));

  return {
    data,
    isLoading,
    error,
  };
}
